import { formatDateTime } from '../../../lib/datetime';
import type { SourceSystemPanelState } from '../types/source-system';
import { SyncStatusBadge } from './SyncStatusBadge';

interface SourceSystemDataSectionProps {
  state: SourceSystemPanelState | null;
}

/**
 * §1 Sync Results section.
 * Displays per-resource ingestion status table.
 */
export function SourceSystemDataSection({ state }: SourceSystemDataSectionProps) {
  const resources = state?.resources ?? [];

  return (
    <section className="ss-section" aria-labelledby="ss-data-heading">
      <div className="ss-section__header">
        <h2 className="ss-section__title" id="ss-data-heading">
          Sync Results
        </h2>
      </div>
      <div className="ss-section__body">
        {resources.length === 0 ? (
          <p className="ss-hint">No resources are configured for this source type.</p>
        ) : (
          <table className="ss-data-table">
            <thead>
              <tr>
                <th>Resource</th>
                <th>Last sync</th>
                <th>Status</th>
                <th>Fetched</th>
                <th>New</th>
                <th>Updated</th>
                <th>Failed</th>
              </tr>
            </thead>
            <tbody>
              {resources.map((r) => (
                <tr key={r.resourceUuid}>
                  <td className="ss-data-table__name">
                    <span>{r.providerResourceName}</span>
                    {r.selectedBranch && (
                      <span className="ss-data-table__branch">{r.selectedBranch}</span>
                    )}
                  </td>
                  <td className="ss-data-table__date">{formatDateTime(r.lastRunAt)}</td>
                  <td>
                    <SyncStatusBadge status={r.lastRunStatus} />
                  </td>
                  <td className="ss-data-table__num">{r.recordsFetched}</td>
                  <td className="ss-data-table__num">{r.recordsCreated}</td>
                  <td className="ss-data-table__num">{r.recordsUpdated}</td>
                  <td
                    className={`ss-data-table__num${r.recordsFailed > 0 ? ' ss-data-table__num--warn' : ''}`}
                  >
                    {r.recordsFailed}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
}
